// src/components/ui/Spinner.tsx
import React from "react";
import { useTranslation } from "react-i18next"

type SpinnerProps = {
  size?: "xs" | "sm" | "md" | "lg";
  className?: string;
  "aria-label"?: string;
};

const sizeMap: Record<NonNullable<SpinnerProps["size"]>, string> = {
  xs: "h-3 w-3",
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-6 w-6",
};

/**
 * CSS-only border spinner.
 * - Inherits color from parent (currentColor).
 * - Minimal markup, zero SVG/icon deps.
 * - Accessible via role/status + aria-label.
 */
export default function Spinner({
  size = "sm",
  className = "",
  "aria-label": ariaLabel,
}: SpinnerProps) {
  const sizeClasses = sizeMap[size];
  const { t } = useTranslation();
  return (
    <span
      role="status"
      aria-live="polite"
      aria-label={ariaLabel ?? t("common.loading")}
      className={[
        "inline-block",
        "animate-spin",
        "rounded-full",
        "border-2",
        "border-current",
        "border-t-transparent",
        sizeClasses,
        className || "",
      ].join(" ")}
    />
  );
}
